export const Z_INDEX_MENU = 15;
export const Z_INDEX_HEADER = 20;
export const Z_INDEX_VERTICAL_MENU = 12;
export const Z_INDEX_DISCOVER_FEATURE = 900;
export const Z_INDEX_SIDE_BAR = 700;
export const Z_INDEX_MODAL = 10005;
export const Z_INDEX_DOCUMENT_PREVIEW = 1100;
export const Z_INDEX_MAX = 999;
